import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "check-connection drv-px-0-5" }

import { computed, watch } from "vue";
import {
  ECommonMessages,
  EConnectionCheckStatus,
  EPlatformName,
  ETelematicsMessagesKeys,
  TTelematicsCredsModel,
} from "../../../types";
import { postConnectionCheck } from "../../../services";
import { useUIKit } from "draivn-ui-kit";
import { injector } from "@/services";
import { I18N_SERVICE_INJECTION_KEY } from "@/constants";
import { CHECK_CONNECTION_MESSAGES } from "../../../constants";


export default /*@__PURE__*/_defineComponent({
  __name: 'CheckConnection',
  props: {
    creds: {},
    platformType: {},
    loading: { type: Boolean },
    url: {},
    isModelFullfiled: { type: Boolean },
    modelValue: { type: [Boolean, null] },
    hiddenClearButton: { type: Boolean },
    hiddenNotification: { type: Boolean }
  },
  emits: ["update:modelValue", "update:loading", "clear"],
  setup(__props: any, { emit: __emit }) {

const t = injector.injectFromRoot(I18N_SERVICE_INJECTION_KEY).global.t;

const $uiKit = useUIKit();

const props = __props;

const emit = __emit;

const loadingModel = computed<boolean>({
  get() {
    return props.loading;
  },
  set(value: boolean) {
    emit("update:loading", value);
  },
});

const checkConnection = async () => {
  loadingModel.value = true;
  try {
    const response = await postConnectionCheck({
      platform_type: props.platformType,
      url: props.url,
      credentials: props.creds,
    });
    if (response?.connected) {
      emit("update:modelValue", true);
    } else {
      emit("update:modelValue", false);
      if (!props.hiddenNotification) {
        $uiKit.notify({
          message: t(ETelematicsMessagesKeys.CHECK_CONNECTION_ERROR_TITLE),
          caption: response?.reason_code
            ? t(CHECK_CONNECTION_MESSAGES[response.reason_code])
            : t(ETelematicsMessagesKeys.CHECK_CONNECTION_ERROR_SUBTITLE),
          icon: "error_outline",
          type: "draivn-toast-notify",
        });
      }
    }
  } catch (e) {
    emit("update:modelValue", false);
  }
  loadingModel.value = false;
};

const clearConnection = () => {
  emit("clear");
};

watch(
  () => props.creds,
  () => {
    emit("update:modelValue", null);
  },
  { deep: true }
);

return (_ctx: any,_cache: any) => {
  const _component_d_btn = _resolveComponent("d-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.modelValue)
      ? (_openBlock(), _createBlock(_component_d_btn, {
          key: 0,
          class: _normalizeClass(["drv-color-n0", {
        'drv-bg-color-b400': !_ctx.modelValue && !loadingModel.value,
        'drv-bg-color-n600': loadingModel.value,
      }]),
          icon: loadingModel.value ? '' : 'refresh',
          onClick: checkConnection,
          loading: loadingModel.value,
          label: _ctx.$t(_unref(ETelematicsMessagesKeys).CHECK_CONNECTION_TITLE),
          disable: !_ctx.isModelFullfiled
        }, null, 8, ["class", "icon", "loading", "label", "disable"]))
      : (_openBlock(), _createBlock(_component_d_btn, {
          key: 1,
          class: "connected-status drv-color-n0 drv-bg-color-g400",
          icon: "circle-check",
          label: _ctx.$t(_unref(ETelematicsMessagesKeys).CHECK_CONNECTION_CONNECTED_STATUS)
        }, null, 8, ["label"])),
    (!_ctx.hiddenClearButton && _ctx.isModelFullfiled)
      ? (_openBlock(), _createBlock(_component_d_btn, {
          key: 2,
          variant: "secondary",
          disable: loadingModel.value,
          onClick: clearConnection,
          label: _ctx.$t(_unref(ECommonMessages).CLEAR)
        }, null, 8, ["disable", "label"]))
      : _createCommentVNode("", true)
  ]))
}
}

})